import { MerchantApplicationsListModule } from '@/components/modules/MerchantDetail/MerchantApplicationsList/MerchantApplicationsList';
import { MerchantComplianceModule } from '@/components/modules/MerchantDetail/MerchantCompliance/MerchantCompliance';
import { MerchantInLenderContextModule } from '@/components/modules/MerchantDetail/MerchantInLenderContext/MerchantInLenderContext';
import { MerchantLenderOrchestrationModule } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/MerchantLenderOrchestration';
import { MerchantOverviewModule } from '@/components/modules/MerchantDetail/MerchantOverview/MerchantOverview';
import { MerchantStructureModule } from '@/components/modules/MerchantDetail/MerchantStructure/MerchantStructure';
import { MerchantUserListModule } from '@/components/modules/MerchantDetail/MerchantUserList/MerchantUserList';
import { MetricMerchantViewsModule } from '@/components/modules/Metrics/MetricMerchantViews/MetricMerchantViews';
import { WebhooksModule } from '@/components/modules/Webhooks/Webhooks';
import { PAGE_MERCHANT_ALLOWED_ROLES } from '@/components/views/DynamicPageView/config/layoutScheme/constants/PageMerchantAllowedRoles';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_MERCHANT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.MERCHANT,
  schemesByRoles: [
    {
      roles: PAGE_MERCHANT_ALLOWED_ROLES,
      titleTextId: 'MERCHANT',
      widgets: [
        { id: WIDGETS.MERCHANT_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
        { id: WIDGETS.MERCHANT_DETAIL_ACTIONS_WIDGET, roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN], props: {} },
      ],
    },
  ],
  sections: [
    {
      textId: 'MERCHANT_DETAIL',
      module: (
        <MerchantOverviewModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
          showInternalData
        />
      ),
    },
    {
      textId: 'MERCHANT_DETAIL',
      module: (
        <MerchantOverviewModule
          permissions={{
            view: [APP_USER_TYPES.LENDER, APP_USER_TYPES.PARTNER, APP_USER_TYPES.MERCHANT_GROUP],
            edit: [],
          }}
        />
      ),
    },
    {
      textId: 'MERCHANT_STRUCTURE',
      module: (
        <MerchantStructureModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'LENDER_ORCHESTRATION',
      module: (
        <MerchantLenderOrchestrationModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'FINANCIAL_ENTITIES',
      module: (
        <MerchantInLenderContextModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'USER_CREDENTIALS',
      module: (
        <MerchantUserListModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'WEBHOOKS',
      module: (
        <WebhooksModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.MERCHANT_GROUP,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.PARTNER, APP_ROLES.MERCHANT_GROUP],
          }}
          hideMerchantHints
        />
      ),
    },
    {
      textId: 'COMPLIANCE',
      module: (
        <MerchantComplianceModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: 'MERCHANT_METRICS',
      module: (
        <MetricMerchantViewsModule
          permissions={{
            view: [...ALL_CORE_APP_USER_TYPES],
          }}
        />
      ),
    },
    {
      textId: 'APPLICATIONS_LIST',
      module: (
        <MerchantApplicationsListModule
          permissions={{
            view: [...ALL_CORE_APP_USER_TYPES],
          }}
        />
      ),
    },
    // {
    //   textId: 'METRICS',
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: [<LoanStats />],
    //     },
    //   ],
    // },
    // {
    //   textId: 'LENDERS',
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    //       modules: [
    //         <LendersStats />,
    //         // <AssignedLenders /> TODO
    //       ],
    //     },
    //   ],
    // },
    // {
    //   textId: 'MERCHANT_STRUCTURE',
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: [<ChannelsAndAgents />, <MerchantStatistics />],
    //     },
    //   ],
    // },
    // {
    //   textId: "COMPLIANCE",
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: ["<LoanStatsModule/>", "<LendersStatsModule/>"],
    //     },
    //   ],
    // },
    // {
    //   textId: "PAYMENT_METHOD",
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: ["<LoanStatsModule/>", "<LendersStatsModule/>"],
    //     },
    //   ],
    // },
    // {
    //   textId: "RISK",
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: ["<LoanStatsModule/>", "<LendersStatsModule/>"],
    //     },
    //   ],
    // },
    // {
    //   textId: "FRAUD",
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: ["<LoanStatsModule/>", "<LendersStatsModule/>"],
    //     },
    //   ],
    // },
    // {
    //   textId: "PRODUCTS",
    //   schemesByRoles: [
    //     {
    //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LENDER],
    //       modules: ["<LoanStatsModule/>", "<LendersStatsModule/>"],
    //     },
    //   ],
    // },
  ],
};
